import { stats } from "@/mocks/homeData";

export default function StatsBar() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 py-10 md:py-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-4 rounded-xl bg-background-100">
              <p className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                {stat.value}
              </p>
              <p className="text-sm text-foreground-600 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}